import { log } from './log';
import { o as obs } from './observable';
import { lang } from './page';
import { profile } from './profile';

let tokenPromise = null;
let analyticsPromise = null;

function embedStub(handler, c, o, v, e, O, u, a) {
  a = 'coveoua';
  c[a] =
    c[a] ||
    function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
  c[a].t = Date.now();
  u = o.createElement(v);
  u.async = 1;
  u.onload = handler;
  u.src = e;
  O = o.getElementsByTagName(v)[0];
  O.parentNode.insertBefore(u, O);

  return u;
}

export async function getCoveoCustomContext() {
  const userProfile = await profile(true);

  return userProfile !== null
    ? {
        context_contentLanguage: lang,
        context_entitlements: userProfile.entitlements,
        context_role: userProfile.role,
        context_interests: userProfile.interests,
        context_industryInterests: userProfile.industryInterests,
      }
    : {};
}

async function coveoAnalyticsInit(token) {
  const customContext = await getCoveoCustomContext();

  if (typeof CoveoForSitecoreUserContext !== 'undefined') {
    var currentContext = CoveoForSitecoreUserContext.handler.getContext(); // eslint-disable-line
    Object.keys(currentContext).forEach((key) => {
      customContext[`c_context_${key}`] = currentContext[key];
    });
  }

  window.coveoua('onLoad', () => {
    // eslint-disable-line
    window.coveoua('init', token); // eslint-disable-line
    // It's unclear whether "pageview" or "view" events are what's expected
    // for our CR, so just send both.
    window.coveoua('send', 'pageview', customContext); // eslint-disable-line
    window.coveoua('send', 'view', customContext); // eslint-disable-line
    log('Coveo Analytics initialized');
  });
}

export function coveoAnalytics() {
  if (analyticsPromise === null) {
    analyticsPromise = new Promise((resolve) => {
      embedStub(resolve, window, document, 'script', 'https://static.cloud.coveo.com/coveo.analytics.js/2/coveoua.js');
    });
  }

  // Auth -should- be loaded at this point in all cases.
  // If we run into an issue where it isn't this would be the place to fix it.
  if (tokenPromise === null) {
    tokenPromise = new Promise((resolve) => {
      obs.once('coveoToken', async (token) => resolve(token));
    });
  }

  return Promise.all([tokenPromise, analyticsPromise]).then((values) => {
    coveoAnalyticsInit(values[0]);
  });
}
